import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetDealerUseCase extends UseCase {
  constructor({getDealerService, getDealerRequestFactory}) {
    super()

    this._getDealerService = getDealerService
    this._getDealerRequestFactory = getDealerRequestFactory
  }

  @tracer({metric: 'GetDealerUseCase#execute'})
  @inlineError
  async execute({contractId} = {}) {
    const requestVO = this._getDealerRequestFactory({contractId})

    const [error, dealerEntity] = await this._getDealerService.execute({
      requestVO
    })

    if (error) return Promise.reject(error)

    return dealerEntity && dealerEntity.toJSON()
  }
}
